import { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

let uniqueIdCounter = 0;

const useTabIndex = (uniqueKey) => {
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [secondActiveTabIndex, setSecondActiveTabIndex] = useState(0);
  const location = useLocation();
  const navigate = useNavigate();

  const instanceIdRef = useRef(uniqueIdCounter++);
  const stateKey = uniqueKey || `tabState_${instanceIdRef.current}`;

  useEffect(() => {
    const savedState = location.state?.[stateKey];
    setActiveTabIndex(savedState?.activeTabIndex ?? 0);
    setSecondActiveTabIndex(savedState?.secondActiveTabIndex ?? 0);
  }, [location.state, stateKey]);

  const onTabChange = (index, secondIndex = 0) => {
    setActiveTabIndex(index);
    setSecondActiveTabIndex(secondIndex);
    navigate(location.pathname, {
      state: {
        ...location.state,
        [stateKey]: { activeTabIndex: index, secondActiveTabIndex: secondIndex }
      }
    });
  };

  return {
    activeTabIndex,
    secondActiveTabIndex,
    onTabChange
  };
};

export default useTabIndex;
